import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { NotificationBaseComponentDirective } from '../../modeles/notification-base-component';

@Component({
  selector: 'app-preautorisation-notification-dsd',
  templateUrl: './preautorisation-notification-dsd.component.html',
  standalone: false
})
export class PreautorisationNotificationDsdComponent extends NotificationBaseComponentDirective implements OnDestroy {
  ngOnDestroy(): void {
    this.closeNotification();
  }
}
